<template>
  <div class="ts-p-3">
    <div class="ts-overflow-y-scroll max-h">
      <table class="ts-w-full">
        <thead>
          <tr>
            <th class="ts-text-center" style="width: 2%">
              {{ $t('no') }}
            </th>
            <th style="width: 12%">
              {{ $t('purchaseRequest.productGroup') }}
            </th>
            <th style="width: 12%">
              {{ $t('purchaseRequest.barcode') }}
            </th>
            <th style="width: 15%">
              {{ $t('purchaseRequest.productName') }}
            </th>
            <th class="ts-text-center" style="width: 8%">
              {{ $t('purchaseRequest.uom') }}
            </th>
            <th class="ts-text-center" style="width: 8%">
              {{ $t('purchaseRequest.quantity') }}
            </th>
            <th class="ts-text-center" style="width: 8%">
              {{ $t('purchaseRequest.cost') }}
            </th>
            <th class="ts-text-center" style="width: 8%">
              {{ $t('purchaseRequest.total') }}
            </th>
            <th class="ts-text-center" style="width: 10%">
              {{ $t('purchaseRequest.maxReorder') }}
            </th>
            <th class="ts-text-center" style="width: 10%">
              {{ $t('purchaseRequest.alloworder') }}
            </th>
            <th style="width: 15%">
              {{ $t('purchaseRequest.remarks') }}
            </th>
            <th class="ts-text-center" style="width: 3%">
              <a href="#" class="ts-text-white" @click.prevent="addNewRow">
                <i class="fa fa-plus"></i>
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="model.details == 0">
            <td colspan="13" class="ts-text-center ts-p-3 ts-space-x-1">
              <i class="fa fa-folder-open ts-text-gray-200"></i>
              <label class="ts-text-gray-400">
                {{ $t('noData') }}
              </label>
              <div class="validate ts-text-left" v-if="errors.has('po_detail')">
                {{ errors.first('po_detail') }}
              </div>
            </td>
          </tr>
          <tr v-for="(d, index) in model.details" :key="index">
            <td class="ts-text-center">
              {{ index + 1 }}
            </td>
            <td>
              <input
                type="text"
                class="form-control"
                style="min-width: 50px"
                :value="
                  findProduct(d.product_id)
                    ? findProduct(d.product_id).pro_group_name_en
                    : ''
                "
                readonly
              />
            </td>
            <td>
              <input
                type="text"
                class="form-control"
                style="min-width: 50px"
                :value="
                  findProduct(d.product_id)
                    ? findProduct(d.product_id).barcode
                    : ''
                "
                readonly
              />
            </td>
            <td>
              <input
                type="text"
                :value="
                  findProduct(d.product_id)
                    ? findProduct(d.product_id).product_name_en
                    : ''
                "
                class="form-control"
                readonly
                style="min-width: 200px"
              />
            </td>
            <td>
              <a-select
                v-model="d.uom_id"
                class="ts-w-full"
                style="min-width: 70px"
                :options="getUnitOfMeasures(d.uom_cat_id)"
                option-filter-prop="children"
                :class="{
                  'is-invalid': errors.has('po_detail.' + index + '.uom_id')
                }"
              >
              </a-select>
            </td>
            <td>
              <input
                v-model.number="d.quantity"
                type="number"
                ref="quantity"
                class="form-control ts-text-center"
                :class="{
                  'is-invalid': errors.has('po_detail.' + index + '.quantity')
                }"
                style="min-width: 70px"
              />
              <div
                class="validate"
                v-if="errors.has('po_detail.' + index + '.quantity')"
              >
                {{ errors.first('po_detail.' + index + '.quantity') }}
              </div>
            </td>
            <td>
              <ts-currency-input
                :value="d.input_unit_price"
                class="form-control ts-text-right"
                style="min-width: 100px;"
                :currency="defaultCurrency.currency_symbol"
                :precision="defaultCurrency.currency_rounding"
                @input="value => onCostInput(value, d)"
              />
              <div
                class="validate"
                v-if="errors.has('po_detail.' + index + '.quantity')"
              >
                {{ errors.first('po_detail.' + index + '.quantity') }}
              </div>
            </td>
            <td>
              <ts-currency-input
                :value="d.input_total"
                class="form-control ts-text-right"
                style="min-width: 100px;"
                :currency="defaultCurrency.currency_symbol"
                :precision="defaultCurrency.currency_rounding"
                :disabled="true"
              />
              <div
                class="validate"
                v-if="errors.has('po_detail.' + index + '.quantity')"
              >
                {{ errors.first('po_detail.' + index + '.quantity') }}
              </div>
            </td>
            <td>
              <input
                v-model="d.maximum_reorder_allow"
                type="text"
                class="form-control ts-text-center"
                style="min-width: 90px"
                readonly
              />
              <div
                class="validate"
                v-if="
                  errors.has('po_detail.' + index + '.maximum_reorder_allow')
                "
              >
                {{
                  errors.first('po_detail.' + index + '.maximum_reorder_allow')
                }}
              </div>
            </td>
            <td style="width: 1%" class="ts-text-center">
              <input type="checkbox" v-model="d.alloworder" />
            </td>
            <td class="ts-whitespace-no-wrap">
              <textarea
                v-model="d.remarks"
                class="form-control"
                style="min-width: 150px;width: 100%"
                rows="1"
                placeholder="remarks"
              ></textarea>
            </td>
            <td style="min-width: 35px" class="ts-text-center">
              <a
                href="#"
                class="ts-text-red-700 hover:ts-text-red-700"
                @click.prevent="removeItem(index)"
              >
                <i class="fa fa-trash"></i>
              </a>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="total-footer">
            <td colspan="4">
              <b>
                {{ $t('purchaseRequest.numberRow') }} :
                {{ model.details.length }}
              </b>
            </td>
            <td class="ts-text-right">
              <b>{{ $t('purchaseRequest.total') }} :</b>
            </td>
            <td>
              <input
                v-model.number="sumTotalQty"
                type="number"
                class="form-control ts-text-center"
                style="min-width: 100px;border:transparent;"
                readonly
              />
            </td>
            <td></td>
            <td>
              <ts-currency-input
                v-model.number="sumTotal"
                class="form-control ts-text-right ts-font-bold"
                style="min-width: 100px;border:transparent;"
                :currency="defaultCurrency.currency_symbol"
                :precision="defaultCurrency.currency_rounding"
                :disabled="true"
              />
            </td>
            <td colspan="4"></td>
          </tr>
        </tfoot>
      </table>

      <!-- modal show pop-up to be able add product -->
      <a-modal
        v-if="show_modal_add_product"
        v-model="show_modal_add_product"
        :footer="null"
        :zIndex="1020"
        :maskClosable="false"
        width="900px"
        :title="$t('stockIn.product')"
      >
        <ProductList v-model="model" />
      </a-modal>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import ProductList from './product-list.vue'
import { sumBy } from 'lodash'

export default {
  name: 'purchaseRequestItem',
  components: {
    ProductList
  },
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      show_modal_add_product: false,
      model: {}
    }
  },
  computed: {
    ...mapState('purchaseRequest/purchaseRequest', [
      'edit_data',
      'formViewDatas'
    ]),
    products() {
      if (this.formViewDatas['products']) {
        return this.formViewDatas['products']
      }
      return []
    },
    unitOfMeasures() {
      if (this.formViewDatas['unitOfMeasures']) {
        return this.formViewDatas['unitOfMeasures'].map(el => ({
          value: el.uom_id,
          label: el.uom_name_en,
          uom_cat_id: el.uom_cat_id,
          is_default: el.is_default,
          stockout_quantity: el.stockout_quantity
        }))
      }
      return []
    },
    defaultCurrency() {
      if (this.$store.state.exchangeRate.currency.formViewDatas['default']) {
        return this.$store.state.exchangeRate.currency.formViewDatas['default']
      }
      return {
        currency_symbol: '$',
        currency_rounding: 2
      }
    },
    sumTotalQty() {
      return sumBy(this.model.details, 'quantity')
    },
    sumTotal() {
      return sumBy(this.model.details, 'total')
    },
    isEdit() {
      return Object.keys(this.edit_data).length
    }
  },
  created() {
    this.model = this.value
  },
  methods: {
    findProduct(product_id) {
      return this.products.find(el => el.product_id == product_id)
    },
    getUnitOfMeasures(uom_cat_id) {
      return this.unitOfMeasures.filter(el => el.uom_cat_id == uom_cat_id)
    },
    addNewRow() {
      this.show_modal_add_product = true
    },
    removeItem(index) {
      this.model.details.splice(index, 1)
    },
    calculate() {
      this.model.details.forEach(el => {
        el.input_total = el.input_unit_price * el.quantity

        el.total = el.input_total * el.fx_rate_ratio
      })
    },
    onCostInput(value, d) {
      d.input_unit_price = value
      d.unit_price = value
      this.calculate()
    },
  },
  watch: {
    'model.details': {
      handler() {
        this.calculate()
      },
      deep: true
    },
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style scoped>
.form-control[disabled],
.form-control[readonly],
fieldset[disabled] .form-control {
  opacity: 1;
}

.py {
  padding: 0.45rem 0;
}

.max-h {
  min-height: 30vh;
  max-height: 50vh;
}

table {
  position: relative;
  border-collapse: collapse;
}

table thead tr th {
  padding: 4px 5px;
  z-index: 3;
  position: sticky;
  top: 0;
  /* Don't forget this, required for the stickiness */
  background-color: rgb(22, 102, 145);
  color: white;
  text-transform: uppercase;
  border-width: 1px;
  white-space: nowrap;
}

table tbody tr td {
  padding: 4px 5px;
  border-width: 1px;
}

table tfoot tr {
  background-color: #e3e8f1;
  border-width: 1px;
}

table tfoot tr td {
  padding: 0 5px;
  white-space: nowrap;
  color: #c53030;
}

.total-footer .form-control {
  font-weight: 900;
  color: #c53030;
}
</style>
